import React from 'react';
import { ICheckAccountErrorComponentState } from './check-account-error.state';
import { ICheckAccountErrorComponentProps } from './check-account-error.props';
import { Label, DefaultButton } from "@fluentui/react";

export class CheckAccountErrorComponent extends React.Component<ICheckAccountErrorComponentProps, ICheckAccountErrorComponentState> {

  constructor(props: any) {
    super(props);
    this.state = {
      error: decodeURI(window.location.hash.replace('#/check-account-error/', '')).split('Ã³').join('ó').split('Ãº').join('ú')
    }
  }

  render(): JSX.Element {
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
          <h1 className='ms-font-xl ms-fontColor-themePrimary'>Sede electrónica</h1>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
          <Label>{this.state.error}</Label>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
          <DefaultButton
            text='Ir a inicio'
            href='#/home'
          />
        </div>
      </div>
    </div>
  }

  private _closeSession(): void {
    sessionStorage.clear();
    this.setState({});
  }

  private get isAuthenticate(): boolean {
    const token = sessionStorage.getItem('ioip.pqr-web.session.token');
    if (token === null || token === undefined) {
      return false;
    }
    const date = sessionStorage.getItem('ioip.pqr-web.session.expiracion');
    return true;
  }

}